import React from 'react';
import './App.css';
import NavbarComponent from "./components/NavbarComponent"
function App() {


    return (
        <div className="App">
            <NavbarComponent/>
        </div>
    );
}

export default App;
